import styled from "@emotion/styled";
import toggleArrow from "../../../../../../../../assets/img/toggle-arrow.svg";
import { Accordion } from "react-bootstrap";

export const ContentWrapper = styled.div`
  overflow-y: scroll;
`;

export const AccordionWrapper = styled.div``;

export const SettingsAccordion = styled(Accordion)`
  border-bottom: 1px solid rgb(225, 225, 225);
`;

export const AccordionItem = styled(Accordion.Item)`
  border: none;
  background: transparent;
  border-bottom: 0.0625rem solid #3b3b3b;

  &:last-of-type {
    border-bottom: none;
  }
  &:not(.collapsed) {
    border-color: #dee2e6 !important;
  }
`;

export const AccordionHeader = styled(Accordion.Header)`
  background: transparent;

  button {
    padding: 1rem 0rem !important;
    padding-top: 15px;
    background: transparent !important;
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    outline: none !important;
    color: grey;
    box-shadow: none !important;
    &:not(.collapsed) {
      color: grey !important;
    }
    &::after {
      content: "";
      display: inline-block;
      width: 16px; /* Adjust size */
      height: 16px; /* Adjust size */
      background-image: url(${toggleArrow}) !important; /* Use the imported icon here */
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      right: 0px; /* Position the icon to the right */
    }
  }
`;

export const InnerAccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AccordionTitle = styled.span`
  color: #3b3b3b;
  font-size: 14px;
`;

export const AccordionIcon = styled.span``;

export const AccordionBody = styled(Accordion.Body)`
  padding: 0rem;
  padding-top: 0rem;
  padding-bottom: 10px;
`;

export const FieldWrapper = styled.div`
  margin-top: 15px;

  label {
    font-size: 12px;
  }
  & > .toggle-buttons {
    margin-top: 5px;
    padding: 0px;
    height: 45px;
    background-color: #f4f4f4;
    border-radius: 0.875rem;
    div {
      width: 100%;
      height: 45px;
      button {
        font-size: 12px;
        height: 30px;
        display: flex;
        align-items: center;
        border-radius: 8px;
      }
    }
  }
`;
